import { render, staticRenderFns } from "./Empleador.vue?vue&type=template&id=74a8bb3c&"
import script from "./Empleador.vue?vue&type=script&lang=js&"
export * from "./Empleador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports